import React, { useEffect } from 'react'

import { 
    ComponentsDiv
} from '../Styles/Pages/SignUpStyles'

import { 
    Alert, 
    TopBackgroundDiv,
    BottomBackgroundDiv
} from '../Styles/BaseStyles'

import SignUpFields from '../Components/Action/SignUpFields'
import SignUpConfirm from '../Components/Display/SignUpConfirm'

import { useSelector, useDispatch } from 'react-redux'

import { reset } from '../Redux/Slices/SignUpSlice'

function SignUp(props){
    const dispatch = useDispatch()

    const accountCreated = useSelector(state => state.signUp.accountCreated)
    const error = useSelector(state => state.signUp.error)
    const errorPhrase = useSelector(state => state.signUp.errorPhrase)

    var viewer 

    useEffect(() => {
        if(error){
            const timeId = setTimeout(() => {
                dispatch(reset())
            }, 5000)
            return () => {
                clearTimeout(timeId)
            }
        }
    }, [dispatch,error])
    
    if(!accountCreated){
        viewer = <SignUpFields />
    }
    else if(accountCreated && !error){
        viewer = <SignUpConfirm />
    }

    return (
        <>
            <TopBackgroundDiv />
            <BottomBackgroundDiv />
            {error && <Alert style={{top: "0.5rem", position: "absolute"}}>{errorPhrase}</Alert>}
            <ComponentsDiv>
                {viewer}
            </ComponentsDiv>
        </>
    )
}

export default SignUp